import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ColorSwatch } from 'site-modules/shared/components/color-swatch/color-swatch';

import './inventory-colors.scss';

export function InventoryColors({
  exterior = {},
  interior = {},
  exteriorLabel = '',
  interiorLabel = '',
  labelClassName = '',
  className = '',
  defaultStyle = false,
  showUnknownColor = false,
}) {
  const isExterior = Number.isInteger(exterior.r);
  const isInterior = Number.isInteger(interior.r);

  if (!showUnknownColor && !isExterior && !isInterior) return null;

  const exteriorColor = exterior.name || (isExterior ? '' : 'Unknown');
  const interiorColor = interior.name || (isInterior ? '' : 'Unknown');

  const exteriorTitle = `Exterior color${exteriorColor ? `: ${exteriorColor}` : ''}`;
  const interiorTitle = `Interior color${interiorColor ? `: ${interiorColor}` : ''}`;

  return (
    <div className={classNames('inventory-colors', className, { default: defaultStyle })}>
      {(isExterior || showUnknownColor) && (
        <div className="inventory-color d-inline-block">
          {exteriorLabel && <span className={labelClassName}>{exteriorLabel}</span>}
          <ColorSwatch color={exterior} displayColorName={false} title={exteriorTitle} />
        </div>
      )}
      {((isExterior && isInterior) || showUnknownColor) && <span className="me-0_25" />}
      {(isInterior || showUnknownColor) && (
        <div className="inventory-color d-inline-block">
          {interiorLabel && <span className={labelClassName}>{interiorLabel}</span>}
          <ColorSwatch color={interior} displayColorName={false} title={interiorTitle} />
        </div>
      )}
    </div>
  );
}

InventoryColors.propTypes = {
  exterior: PropTypes.shape({
    r: PropTypes.number,
    b: PropTypes.number,
    g: PropTypes.number,
    name: PropTypes.string,
  }),
  interior: PropTypes.shape({
    r: PropTypes.number,
    b: PropTypes.number,
    g: PropTypes.number,
    name: PropTypes.string,
  }),
  exteriorLabel: PropTypes.string,
  interiorLabel: PropTypes.string,
  labelClassName: PropTypes.string,
  className: PropTypes.string,
  defaultStyle: PropTypes.bool,
  showUnknownColor: PropTypes.bool,
};
